import { Box, IconButton, Modal, Paper, Stack } from '@mui/material';
import { Register } from '@/components/content/Register';
import { RegistrationOrigin } from '@/data/Content/Registration';
import {
	ModalLoginFrameSx,
	ModalLoginHeaderIconCloseFrameSx,
	ModalLoginHeaderIconCloseSx,
} from '@/components/blocks/ModalLogin/styles/main';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ZIndex } from '@/utils/zIndex';

interface ModalRegisterProps {
	origin?: RegistrationOrigin;
	onClose: () => void;
	onGoBack: () => void;
	onAuthSuccess?: () => void;
}

export const ModalRegister: React.FC<ModalRegisterProps> = ({
	origin = 'cart',
	onGoBack,
	onClose,
	onAuthSuccess,
}) => (
	<Modal
		open
		slotProps={{
			root: {
				sx: { zIndex: ZIndex.HIGH },
			} as any,
		}}
		onClose={onClose}
	>
		<Paper sx={ModalLoginFrameSx}>
			<Stack direction="row" justifyContent="space-between" width="100%" mt="5px">
				<IconButton onClick={onGoBack} sx={{ ...ModalLoginHeaderIconCloseFrameSx, ml: '10px' }}>
					<ArrowBackIosIcon fontSize="medium" sx={ModalLoginHeaderIconCloseSx} />
				</IconButton>
				<IconButton onClick={onClose} sx={ModalLoginHeaderIconCloseFrameSx}>
					<CloseIcon fontSize="medium" sx={ModalLoginHeaderIconCloseSx} />
				</IconButton>
			</Stack>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: '1fr',
					padding: '0px 40px 30px 40px',
				}}
			>
				<Register
					id="modal-register"
					withoutLogin
					shouldCallToModal
					origin={origin}
					onAuthSuccess={onAuthSuccess}
					onClose={onClose}
				/>
			</Box>
		</Paper>
	</Modal>
);
